import {Box} from 'platform/foundation';

import {ReactNode} from 'react';

export const ComparisonRow = ({children, index}: {children: ReactNode; index?: number}) => {
  const isEven = (index ?? 0) % 2 === 0;
  return (
    <Box
      paddingHorizontal={2}
      paddingVertical={1}
      backgroundColor={isEven ? 'general.white' : 'palettes.neutral.10.100'}
    >
      {children}
    </Box>
  );
};
